import axios from "axios";
import { Env } from "./env";
import { handleSilentLogout } from "../utils/common.fn";

export const API_URL = Env.BASE_URL;
export const CONTENT_HUB_API_URL = Env.CONTENT_HUB_URL;

export const $axios = axios.create({
  baseURL: API_URL,
  timeout: 50000,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

export const $contentHubAxios = axios.create({
  baseURL: CONTENT_HUB_API_URL,
  timeout: 50000,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
    "accept-language": "en-US,en;q=0.9,en-IN;q=0.8",
    brand: "KFC",
    country: "UAE",
    platform: "3",
    "x-api-key": Env.API_KEY,
    "x-api-secret": Env.API_SECRET,
  },
});

$axios.interceptors.request.use(
  (config: any) => {
    const hasAuthHeader =
      config.headers?.Authorization || config.headers?.authorization;

    if (!hasAuthHeader) {
      const idToken = localStorage.getItem("idToken");
      if (idToken) {
        config.headers["Authorization"] = `Bearer ${idToken}`;
      }
    }

    if (config.url?.includes("RefreshAndRedirect")) {
      return config;
    }

    return config;
  },
  (error: any) => {
    console.error("Interceptor Error:", error);
    return Promise.reject(error);
  }
);

$axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      const msalInstance = window.msalInstance;
      handleSilentLogout(msalInstance);
      return Promise.resolve(null);
    }
    return Promise.reject(error);
  }
);

$contentHubAxios.interceptors.request.use(
  (config: any) => {
    const idToken = localStorage.getItem("idToken");
    const parsedIdToken = idToken ?? null;
    if (parsedIdToken) {
      config.headers["Authorization"] = `Bearer ${parsedIdToken}`;
    }
    return config;
  },
  (error: any) => {
    console.error("Content Hub Interceptor Error:", error);
    return Promise.reject(error);
  }
);

$contentHubAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      const msalInstance = window.msalInstance;
      handleSilentLogout(msalInstance);
      return Promise.resolve(null);
    }
    return Promise.reject(error);
  }
);
